import axios from 'axios'

export default {
    store: (data) => axios.post('assets/assign-person/store', data),
    update: (data) => axios.post('assets/assign-person/update', data),
    unassign: (data) => axios.post('assets/assign-person/unassign', data),
    storeVehicle: (data) => axios.post('vehicles/assign-person/store', data),
    updateVehicle: (data) => axios.post('vehicles/assign-person/update', data),
    unassignVehicle: (data) => axios.post('vehicles/assign-person/unassign', data),
}